import Input from "../../Input"

const NewClientsChannel = ({ values, serverData }) => {
    return (
        <div className="mx-14 h-full">
            <h6 className="flex justify-center">چنل کلاینت های جدید هر روز</h6>
            <div className="font-sans">
                <Input
                    type="number"
                    label="ایدی چنل *"
                    name="newClientsChannel-id"
                    options={serverData?.channelList}
                    class="border   text-sm rounded-lg  block w-full p-2.5 bg-gray-700 border-gray-600 placeholder-gray-400 text-white "
                    placeholder="ChannelID"
                    autoComplete="off"
                    defaultValue={values?.id}
                    dir="ltr"
                />
            </div>
            <div className="mt-2">
                <Input
                    type="text"
                    label="دسکریپشن کلاینت"
                    name="newClientsChannel-clientDesc"
                    class="border   text-sm rounded-lg  block w-full p-2.5 bg-gray-700 border-gray-600 placeholder-gray-400 text-white "
                    placeholder="format"
                    autoComplete="off"
                    defaultValue={values?.clientDesc}
                    dir="ltr"
                />
            </div>
            <div className="mt-2">
                <Input
                    type="text"
                    label="فرمت *"
                    name="newClientsChannel-format"
                    class="border   text-sm rounded-lg  block w-full p-2.5 bg-gray-700 border-gray-600 placeholder-gray-400 text-white "
                    placeholder="format"
                    autoComplete="off"
                    defaultValue={values?.format}
                    dir="ltr"
                />
            </div>
            <div className="mt-2">
                <label for="bot-name" class="block">
                    فرمت دسکریپشن
                </label>
                <textarea
                    type="text"
                    row="2"
                    name="newClientsChannel-descFormat"
                    class="styled-input"
                    placeholder="descFormat"
                    autoComplete="off"
                    defaultValue={values?.descFormat}
                    dir="ltr"
                />
            </div>
            <div className="mt-5 p-2 text-gray-400 border-gray-700 border rounded-md font-sans">
                <span>متغیرهای دسکریپشن کلاینت:</span>
                <div dir="ltr">
                    <div>%name: اسم</div>
                </div>
                <span>متغیرهای اسم چنل:</span>
                <div dir="ltr">
                    <div>%c: تعداد</div>
                </div>
                <hr className="bg-gray-500 border-none h-[2px] w-full" />
                <span>متغیرهای دسکریپشن چنل:</span>
                <div className="grid grid-cols-3" dir="ltr">
                    <div>%name: اسم</div>
                    <div>%i: شاخص</div>
                    <div>%clock: ساعت ورود</div>
                </div>
            </div>
        </div>
    )
}

export default NewClientsChannel
